import { api } from '@/api/client'
import type { BetExperience, BetPick, PhoneState } from '@/types/game'

/** Der komplette Zustand für dieses Handy. */
export function fetchState(): Promise<PhoneState> {
    return api<PhoneState>('/state')
}

export function submitSurvey(betExperience: BetExperience, knowledge: number): Promise<unknown> {
    return api('/survey', { method: 'POST', body: { betExperience, knowledge } })
}

/** Ein Tipp auf ein Spiel, angesprochen über seine Position 1–10. */
export function submitBet(position: number, pick: BetPick): Promise<unknown> {
    return api('/bets', { method: 'POST', body: { position, pick } })
}

/** Gibt den Wettschein ab; offene Spiele gelten danach als ausgelassen. */
export function submitBetSlip(): Promise<unknown> {
    return api('/bets/submit', { method: 'POST', body: {} })
}

export function submitAssessment(guess: number, confidence: number): Promise<unknown> {
    return api('/assessment', { method: 'POST', body: { guess, confidence } })
}
